import { UrlConstants } from "../url.constants";
export class ApiRatesCertificateConstants {
    static URL = UrlConstants.API_V2 + "RatesCertificate";
    static FUNCTION_SET_APPLICANT_AND_APPLICANT_AGENT = "";
    static FUNCTION_CREATE_PARTIAL_APPLICATION = "CreatePartialPortalRatesCertificateApplication";
    static FUNCTION_CREATE_RESUBMITTED_APPLICATION = "CreateResubmittedPortalRatesCertificateApplication";
    static FUNCTION_GET_MY_AFLA_PORTAL_RC_APPLICATIONS = "GetMyAFLAPortalRatesCertificateApplications";
    static FUNCTION_GET_ALL_AFLA_PORTAL_RC_APPLICATIONS = "GetAllAFLAPortalRatesCertificateApplications";
}
